import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.franchisee.editors.FranchiseeBranchEditor.';

  public static readonly branchSettings = `${Id.prefix}branchSettings`;
  public static readonly branchName = `${Id.prefix}branchName`;
  public static readonly abbreviatedName = `${Id.prefix}abbreviatedName`;
  public static readonly taxRegistrationNumber = `${Id.prefix}taxRegistrationNumber`;
  public static readonly branchAddress = `${Id.prefix}branchAddress`;
  public static readonly physicalAddress = `${Id.prefix}physicalAddress`;
  public static readonly billingAddress = `${Id.prefix}billingAddress`;

  // Dialogs and validation
  public static readonly addBranch = `${Id.prefix}addBranch`;
  public static readonly editBranch = `${Id.prefix}editBranch`;
  public static readonly provideTaxRegistrationNumber = `${Id.prefix}provideTaxRegistrationNumber`;
  public static readonly provideBranchName = `${Id.prefix}provideBranchName`;
  public static readonly provideBranchAbbreviatedName = `${Id.prefix}provideBranchAbbreviatedName`;
  public static readonly provideStreetAddress = `${Id.prefix}provideStreetAddress`;
  public static readonly provideZipCode = `${Id.prefix}provideZipCode`;
  public static readonly provideBillingStreetAddress = `${Id.prefix}provideBillingStreetAddress`;
  public static readonly provideBillingAddressPostcode = `${Id.prefix}provideBillingAddressPostcode`;
  public static readonly cancelNewEdit = `${Id.prefix}cancelNewEdit`;
  public static readonly close = `${Id.prefix}close`;
  public static readonly saveBranch = `${Id.prefix}saveBranch`;
  public static readonly labelName = `${Id.prefix}name`;
}

export class LangFranchiseeBranchEditor {
  private constructor() {}

  public static branchSettings(): string {
    return interpolate(Id.branchSettings);
  }

  public static branchName(): string {
    return interpolate(Id.branchName);
  }

  public static abbreviatedName(): string {
    return interpolate(Id.abbreviatedName);
  }

  public static taxRegistrationNumber(): string {
    return interpolate(Id.taxRegistrationNumber);
  }

  public static branchAddress(): string {
    return interpolate(Id.branchAddress);
  }

  public static physicalAddress(): string {
    return interpolate(Id.physicalAddress);
  }

  public static billingAddress(): string {
    return interpolate(Id.billingAddress);
  }

  public static addBranch(): string {
    return interpolate(Id.addBranch);
  }

  public static editBranch(): string {
    return interpolate(Id.editBranch);
  }

  public static provideTaxRegistrationNumber(): string {
    return interpolate(Id.provideTaxRegistrationNumber);
  }

  public static provideBranchName(): string {
    return interpolate(Id.provideBranchName);
  }

  public static provideBranchAbbreviatedName(): string {
    return interpolate(Id.provideBranchAbbreviatedName);
  }

  public static provideStreetAddress(): string {
    return interpolate(Id.provideStreetAddress);
  }

  public static provideZipCode(): string {
    return interpolate(Id.provideZipCode);
  }

  public static provideBillingStreetAddress(): string {
    return interpolate(Id.provideBillingStreetAddress);
  }

  public static provideBillingAddressPostcode(): string {
    return interpolate(Id.provideBillingAddressPostcode);
  }

  public static cancelNewEdit(): string {
    return interpolate(Id.cancelNewEdit);
  }

  public static close(): string {
    return interpolate(Id.close);
  }

  public static saveBranch(): string {
    return interpolate(Id.saveBranch);
  }

  public static labelName(): string {
    return interpolate(Id.labelName);
  }
}

export class FranchiseeBranchEditorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.branchSettings, "{{glossary 'branch'}} Settings", 'Heading for branch settings section');
    register.add(Id.branchName, "{{glossary 'branch'}} Name", 'Label for branch name column');
    register.add(Id.abbreviatedName, 'Abbreviated Name', 'Label for branch abbreviated name column');
    register.add(Id.taxRegistrationNumber, 'Tax Registration #', 'Label for branch tax registration number');
    register.add(Id.branchAddress, 'Branch Address', 'Section title for branch address');
    register.add(Id.physicalAddress, 'Physical Address', 'Label for physical address column');
    register.add(Id.billingAddress, 'Billing Address', 'Label for billing address column');

    // Dialogs and validation
    register.add(Id.addBranch, "Add {{glossary 'branch'}}", 'Dialog title for adding a branch');
    register.add(Id.editBranch, "Edit {{glossary 'branch'}}", 'Dialog title for editing a branch');
    register.add(
      Id.provideTaxRegistrationNumber,
      "Please provide a {{glossary 'tax'}} Registration Number",
      'Validation for tax registration number'
    );
    register.add(Id.provideBranchName, "Please provide a {{glossary 'branch'}} name", 'Validation for branch name');
    register.add(
      Id.provideBranchAbbreviatedName,
      "Please provide a {{glossary 'branch'}} abbreviated name",
      'Validation for branch abbreviated name'
    );
    register.add(Id.provideStreetAddress, 'Please provide a Street Address', 'Validation for street address');
    register.add(Id.provideZipCode, 'Please provide a Zip Code', 'Validation for zip code');
    register.add(
      Id.provideBillingStreetAddress,
      'Please provide a Billing Street Address',
      'Validation for billing street address'
    );
    register.add(
      Id.provideBillingAddressPostcode,
      'Please provide a Billing Address Postcode',
      'Validation for billing address postcode'
    );
    register.add(Id.cancelNewEdit, 'Cancel New Edit', 'Cancel new edit dialog');
    register.add(Id.close, 'Close', 'Button label for close');
    register.add(Id.saveBranch, "Save {{glossary 'branch'}}", 'Button label for save branch');
    register.add(Id.labelName, 'Name', 'Label for branch name field');
  }
}
